// https://vuex.vuejs.org/en/state.html

export default {
  activeTab: 0,
  form: {},
  projects: []
}
